var _g, _rect, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStopRecording(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4 30.8C32.4118 30.8 30.8 32.4118 30.8 34.4V49.6C30.8 51.5883 32.4118 53.2001 34.4 53.2001H49.6C51.5883 53.2001 53.2001 51.5883 53.2001 49.6V34.4C53.2001 32.4118 51.5883 30.8 49.6 30.8H34.4Z",
    fill: "#E71561"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 10.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#E71561"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 42,
    cy: 42,
    r: 36.5,
    stroke: "#E71561"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 42,
    cy: 42,
    r: 41.5,
    stroke: "#E71561"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopRecording);
export default __webpack_public_path__ + "static/media/stop_recording.25ca1e5300a232fe082866d4063f5f92.svg";
export { ForwardRef as ReactComponent };